import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

import { TenantService, UserService } from '@celum/authentication';
import { CelumPropertiesProvider, isTruthy } from '@celum/core';
import { AdminMenuComponent } from '@celum/formats/features/tenant-admin';
import { AdminService } from '@celum/formats/shared';
import { SystembarComponent, SystembarConfiguration } from '@celum/shared/ui';
import { LanguageInitializationService, removeCelumLoadingOverlay, UserPilot } from '@celum/shared/util';

@Component({
  imports: [RouterModule, SystembarComponent, AdminMenuComponent],
  selector: 'formats-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  protected adminService = inject(AdminService);

  private userPilot = inject(UserPilot);
  private tenantService = inject(TenantService);
  private userService = inject(UserService);

  constructor() {
    inject(LanguageInitializationService).init();

    this.updateUserPilotInfo();
  }

  private async updateUserPilotInfo(): Promise<void> {
    const userPilotActive = await this.userPilot.initializeIfConfigured();

    if (!userPilotActive) {
      return;
    }

    const user = await firstValueFrom(this.userService.currentUser$.pipe(isTruthy(), take(1)));
    const tenantId = this.tenantService.getCurrentTenantId();

    const currentTenant = user.accountAccesses.find(access => access.accountId === tenantId);

    this.userPilot.updateUserInfo({
      userId: `${user.oid}/${tenantId}`,
      role: user.accountAccesses.find(access => access.accountId === tenantId)?.role,
      version: CelumPropertiesProvider.properties.versionInformation.buildNumber,
      company: {
        name: currentTenant?.accountName,
        id: tenantId
      }
    });
  }

  protected systembarConfiguration: SystembarConfiguration = {};

  protected removeLoadingOverlay(): void {
    removeCelumLoadingOverlay();
  }
}
